import { createContext, useContext } from 'react';

export interface CartItem {
  id: string;
  tourId: string;
  slug: string;
  title: string;
  imageUrl: string;
  date: string;
  adults: number;
  children: number;
  babies: number;
  adultPrice: number;
  childPrice: number;
  babyPrice: number;
}

export interface CartContextType {
  cart: CartItem[];
  addItem: (item: Omit<CartItem, 'id'>) => void;
  removeItem: (id: string) => void;
  updateItem: (id: string, updates: Partial<Omit<CartItem, 'id'>>) => void;
  clearCart: () => void;
  totalItems: number;
  totalPrice: number;
}

export const CartContext = createContext<CartContextType | null>(null);

export function useCart(): CartContextType {
  const ctx = useContext(CartContext);
  if (!ctx) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return ctx;
}
